import { CategoryEnum, RackPositionEnum } from "../enums";
import { RmRfidAssocProductModel } from "./rm-rfid-assoc-product.model";

export class RmRfidTagModel{
    plantId: number;
    rfIds: string;
    type: CategoryEnum;
    primaryId: number;
    id: string;
    length: number;
    breadth: number;
    width: number;
    boundaries?: string;
    level?: number;
    position?: RackPositionEnum;
    assocPalletId?: string;
    productInfo?: RmRfidAssocProductModel;


    /**
     * 
     * @param plantId 
     * @param rfIds 
     * @param type 
     * @param primaryId
     * @param id 
     * @param length 
     * @param breadth 
     * @param width 
     * @param boundaries 
     * @param level 
     * @param position 
     * @param assocPalletId 
     * @param productInfo 
     */
    constructor(plantId: number,rfIds: string, type: CategoryEnum,primaryId: number,id: string, length: number,breadth: number,width: number,boundaries?: string,level?: number, position?: RackPositionEnum,assocPalletId?: string,productInfo?: RmRfidAssocProductModel){
        this.plantId = plantId;        
        this.rfIds = rfIds;
        this.type = type;
        this.primaryId = primaryId;
        this.id = id;
        this.length = length;
        this.breadth = breadth;
        this.width = width;
        this.boundaries = boundaries;
        this.level = level;
        this.position = position;
        this.assocPalletId = assocPalletId;
        this.productInfo = productInfo;
    }
}